import { isEmpty } from "lodash"

// import { records } from "./modelizer"

import models from "./models/index.js"
import records from "./serializers/index.js"

const serialize = (recordName, data) => {
  const d = new Promise(async (resolve) => {
    let serializedData = []

    const model = models[recordName] || {}
    let Record = records[recordName] || records.Base

    if (isEmpty(data)) {
      // data is empty, ie. 404, resolve with empty array rather than undefined
      resolve([])
    }
    if (Array.isArray(data)) {
      // if data is an array of objects, loop over them
      data.forEach((vehicle) => {
        const newRecord = new Record(model, vehicle)
        serializedData.push(newRecord)
      })
      resolve(serializedData)
    } else {
      // if data is a single object resolve it directly
      resolve(new Record(model, data))
    }
  })
  return d
}

export default serialize
